import { BitfStore } from '@bitf/core/models/bitf-store.model';
import { Brand, User } from '@models';

// NOTE: default values must be defined in the StoreService, not in the model
// (otherwise the default here will override the super Object.assign())
export class Store extends BitfStore {
  user: User;
  prop1: any;
  brands: Brand[];
  brandId: string;

  constructor(storeData: Partial<Store>) {
    super(storeData);
  }
}
